import { INVESTMENT_REQUEST_STATUS } from "./constants";

export function getRecommendedRequestAction(status) {
  const map = {
    [INVESTMENT_REQUEST_STATUS.PENDING_PAYMENT]: {
      label: "Awaiting payment",
      description:
        "Units are soft-held until the participant completes Paystack payment. Decline or cancel to release the hold.",
      variant: "outline",
    },
    [INVESTMENT_REQUEST_STATUS.SUBMITTED]: {
      label: "Mark under review",
      description: "Begin due diligence and assign a reviewer before approving or declining.",
      variant: "ghost",
    },
    [INVESTMENT_REQUEST_STATUS.UNDER_REVIEW]: {
      label: "Approve or decline",
      description: "Review KYC, units, and opportunity capacity before making a decision.",
      variant: "success",
    },
    [INVESTMENT_REQUEST_STATUS.APPROVED]: {
      label: "Allocate units",
      description: "Legacy path only — online purchases allocate automatically on payment.",
      variant: "teal",
    },
    [INVESTMENT_REQUEST_STATUS.ALLOCATED]: {
      label: "Reservation confirmed",
      description: "Payment received and units reserved. Monitor until maturity or cancel if needed.",
      variant: "outline",
    },
    [INVESTMENT_REQUEST_STATUS.DECLINED]: {
      label: "No further action",
      description: "Request was declined. Participant may submit a new request if eligible.",
      variant: "ghost",
    },
    [INVESTMENT_REQUEST_STATUS.MATURED]: {
      label: "Archive for records",
      description: "Investment has matured. Retain for reporting and audit history.",
      variant: "outline",
    },
    [INVESTMENT_REQUEST_STATUS.CANCELLED]: {
      label: "No further action",
      description: "Request was cancelled by the participant or staff.",
      variant: "ghost",
    },
  };

  return (
    map[status] || {
      label: "Review request",
      description: "Check request status and take the appropriate next step.",
      variant: "outline",
    }
  );
}
